/**
 * Flow scene action creation.
 * Duplicated from Scenes for Flow independence.
 */

import { is_play_scene_action_ui, is_enable_disable_scene_action_ui } from 'src/types/SceneActionUI';
import type { SceneActionUI } from 'src/types/SceneActionUI';
import { delay_action } from './device-actions';

/**
 * Creates a scene action payload for scene JSON.
 */
export function createSceneActionFromFlow(data: SceneActionUI): Record<string, unknown> | undefined {
	let action: Record<string, unknown> | undefined;

	if (is_play_scene_action_ui(data)) {
		if (data.option === 'with_if_evaluation') {
			action = {
				_gui_type: 'activate_scene',
				trigger: `${data.scene_id}`,
			};
		} else {
			action = {
				_gui_type: 'activate_scene',
				trigger: `${data.scene_id}`,
				skipif: true,
			};
		}
	} else if (is_enable_disable_scene_action_ui(data)) {
		const mapActions: Record<string, string> = {
			action_enable_scene: 'true',
			action_disable_scene: 'false',
			action_toggle_scene: 'toggle',
		};
		action = {
			_gui_type: 'enable_disable_scene',
			r: `blprop:${data.scene_id}:enabled`,
			set: String(mapActions[data.option] ?? 'true'),
		};
	} else {
		return undefined;
	}

	if (action && data.delay != null && Number(data.delay.value) > 0) {
		return delay_action(action, data.delay) as Record<string, unknown>;
	}

	return action;
}
